import React, { useEffect, useState } from "react";
import GoogleClassroomLogo from "../../../../assets/images/googleClassroom.png";
import supabase from "../../../../utils/supabase";

const IntegrationStatus = () => {
  const [googleStudentsCount, setGoogleStudentsCount] = useState(0);

  async function getGoogleClassroomCount() {
    const { count: studentsCount, error } = await supabase
      .from("profiles")
      .select("*", { count: "exact", head: true })
      .eq("role", "student")
      .neq("google_student_id", null);

    if (error) {
      console.error(error);
    }

    setGoogleStudentsCount(studentsCount || 0);
  }

  useEffect(() => {
    getGoogleClassroomCount();
  }, []);

  const integrations = [
    {
      name: "Google Classroom",
      status: "Active",
      image: GoogleClassroomLogo,
      bg: "green",
      description: `${googleStudentsCount} student records synced`,
      students: `${googleStudentsCount} student records synced`,
    },
    // {
    //   name: "Clever",
    //   status: "Not Configured",
    //   image: CleverLogo,
    //   bg: "gray",
    //   description: "Click to set up integration",
    // },
    // {
    //   name: "PowerSchool",
    //   status: "Error",
    //   image: PowerSchoolLogo,
    //   bg: "red",
    //   description: "API credentials expired",
    //   trubleshootingButton: true,
    // },
  ];
  return (
    <div className="bg-white rounded-lg shadow-sm mb-6 p-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-medium text-gray-900">
          LMS Integration Status
        </h2>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-2">
        {integrations.map((item, i) => (
          <div
            key={i}
            className={`border rounded-lg p-2 bg-${item.bg}-50 border-${item.bg}-200`}
          >
            <div className="flex justify-between items-center">
              <div className="flex items-center">
                <img src={item.image} alt={item.name} className="h-8 mr-2" />
                <span className="font-medium">{item.name}</span>
              </div>
              <span
                className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-${item.bg}-100 text-${item.bg}-800`}
              >
                {item.status}
              </span>
            </div>
            <div className="mt-4">
              {item.students && (
                <p className="text-sm text-gray-500 mt-1">{item.students}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IntegrationStatus;
